// ---------------------------------------------------------------------------
// The exact "minimal standard" pseudo-random generator (Park & Miller, Comm.
// ACM 31, 1192-1201, Oct 1988; Comm. ACM 36 No. 7, 105-110, July 1993) that
// CalEvBasic's SCE-UA port (SCEUA.vb, functions `ran0`/`urand`/`rninit`) uses
// to seed the initial population and every random fallback point — kept as
// its own module, variable names matching the source, so SCE-UA's own
// randomness can be swapped/tested independently of the optimizer logic.
// A JS Math.random()-backed generator can't be seeded, which would make the
// optimizer's convergence untestable (see sceua.test.ts) and unreproducible
// between calibration runs on the same project.
// ---------------------------------------------------------------------------

const A = 48271;
const M = 2147483647;
const Q = 44488;
const R = 3399;
const EPS = 0.00000012;
const RNMX = 1.0 - EPS;

export class ParkMillerRandom {
  private seed: number;

  constructor(seed: number) {
    this.seed = seed > 0 ? seed : 123456;
  }

  /** Next uniform deviate in (0, 1). */
  next(): number {
    const j = Math.floor(this.seed / Q);
    this.seed = A * (this.seed - j * Q) - R * j;
    if (this.seed < 0) this.seed += M;
    return Math.min(this.seed / M, RNMX);
  }
}
